import { useSession } from '@/features/auth/session-context';
import { RX_REQUEST_PERMISSIONS } from './types';

/**
 * What the active role may do with refill / outside-pharmacy requests
 * (RL-991): the doctor reads and decides (`doctor_inbox:read` / `:manage`),
 * the manager oversees and routes (`doctor_inbox:oversee`). Whether the
 * medicines are shown is the API's `detailsShown`, not this.
 */
export function useRxRequestAccess() {
  const { hasPermission } = useSession();
  const read = hasPermission(RX_REQUEST_PERMISSIONS.read);
  const oversee = hasPermission(RX_REQUEST_PERMISSIONS.oversee);
  return {
    canView: read || oversee,
    canReadInbox: read,
    canDecide: hasPermission(RX_REQUEST_PERMISSIONS.manage),
    canRoute: oversee,
  };
}
